import { useEffect, useState } from 'react';
export const useCountdown = (deltaCountdown) => {
    const countdownDate = new Date(deltaCountdown).getTime();
    const [countdown, setCountdown] = useState(10000); // Setting it to 10s to avoid layout shift
    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown(countdownDate - new Date().getTime());
        }, 1000);
        return () => clearInterval(interval);
    }, [countdownDate, deltaCountdown]);
    return getReturnValues(countdown);
};
const getReturnValues = (countdown) => {
    // calculate time left
    const days = Math.floor(countdown / (1000 * 60 * 60 * 24));
    const hours = Math.floor((countdown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((countdown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countdown % (1000 * 60)) / 1000);
    return [days, hours, minutes, seconds];
};
//# sourceMappingURL=useCountdown.js.map